import { ref } from 'vue'
import { getChatSuggestions } from '@/utils/chatApi'

/**
 * Единый источник стартовых подсказок нового диалога для обычного чата
 * (ChatMessages) и embed-виджета (EmbedChatPage).
 *
 * Подсказки грузятся с бэкенда (Laravel) один раз на сессию (module-level кэш
 * промиса). На кнопках показывается полный `prompt`; `label` — короткая версия
 * для админки. Если запрос упал или вернул пусто — используется дефолтный список,
 * чтобы UI никогда не оставался без подсказок.
 */

// Фолбэк дублирует стартовый набор из миграции chat_prompt_suggestions.
export const DEFAULT_SUGGESTIONS = [
    { id: 'd1', label: 'Топ-10 марок месяца', prompt: 'Дай топ-10 марок за последний месяц' },
    { id: 'd2', label: 'Динамика продаж', prompt: 'Покажи динамику продаж новых легковых' },
    { id: 'd3', label: 'Сравнить две модели', prompt: 'Сравни Haval vs Chery в Москве' },
    { id: 'd4', label: 'Продажи по регионам', prompt: 'Как продажи распределены по регионам?' },
    { id: 'd5', label: 'Прогноз на 2026', prompt: 'Сделай прогноз 2026 с тремя сценариями' },
    { id: 'd6', label: 'Автокредиты по банкам', prompt: 'Покажи статистику автокредитов по банкам' },
]

const suggestions = ref([...DEFAULT_SUGGESTIONS])
let loadPromise = null

function load() {
    if (!loadPromise) {
        loadPromise = getChatSuggestions()
            .then(items => {
                if (Array.isArray(items) && items.length > 0) {
                    suggestions.value = items
                }
                return suggestions.value
            })
            .catch(() => {
                // оставляем дефолтный список
                return suggestions.value
            })
    }
    return loadPromise
}

export function useChatSuggestions() {
    load()
    return { suggestions }
}
